import React, { createContext, useContext, useReducer } from 'react';
import { any, func, object } from 'prop-types';

const AuthContext = createContext();

export function AuthProvider({ reducer, authState = {}, children }) {
  const value = useReducer(reducer, authState);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  reducer: func,
  authState: object,
  children: any,
};

export function useAuth() {
  return useContext(AuthContext);
}
